import React, { useEffect, useState } from "react";
import styles from "../../Styles/forgotpassword/styles.module.css";
import bubbles from "../../images/bubble.png";
import bubble from "../../images/Ellipse 13.png";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import hii from "../../images/eye.svg";
import hello from "../../images/Vector.svg";
import { resetPassword } from "../../helper/authApiCalls/auth";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { isAuthenticated } from "../../helper/authApiCalls/auth";
import bubbles2 from "../../images/Bubbles (1).svg";

const NewCredentials = () => {
  const params = useParams();
  const token = params.token;

  const [values, setValues] = useState({
    password: "",
    confirmPassword: "",
    showpassword: false,
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const onSubmit = (e) => {
    setError("");
    setSuccess(false);
    e.preventDefault();
    const sendData = {
      password: values.password,
      confirmPassword: values.confirmPassword,
    };

    resetPassword(sendData, token).then((data) => {
      if (data.error) {
        setError(data.error);
      } else {
        setError("");
        setValues({ ...values, password: "", confirmPassword: "" });
        setSuccess(true);
      }
    });
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  let navigate = useNavigate();

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showpassword: !values.showpassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (isAuthenticated()) {
      return navigate("/");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const successComponent = () => {
    return (
      <div className={styles.success}>
        <div>
          <p>Your password has been successfully changed.</p>
          <span>
            Try logging in, <a href="/signin">Go to Signin</a>
          </span>
        </div>
      </div>
    );
  };

  const newCredentialsPage = () => {
    return (
      <div className="text">
        <div className={styles.mainbody}>
          <div className={styles.rightflank}>
            <div className={styles.fig}>
              <img src={bubbles} alt="%" />
            </div>

            <div className={styles.name}>
              <div className={styles.uppername}>
                <span>EduUdr</span>
              </div>
              <div className={styles.lowername}>
                <span>upgrading the community</span>
              </div>
            </div>
            <div className={styles.downspans}>
              <div className={styles.upspan}>
                <span>Grow by learning</span>
                <img src={bubble} alt="" />
              </div>
              <div className={styles.downspan}>
                <span>
                  We strive to help and bring together the online learners community by compiling
                  knowledgeable resources from all over the internet.
                </span>
              </div>
            </div>
          </div>
          <div className={styles.leftflank}>
            <div className={styles.mainlog}>
              <span className={styles.newcredentials}>New Credentails</span>
            </div>
            <div className={styles.in}>
              {!success ? (
                <div>
                  <div className={styles.in1}>
                    <TextField
                      label="New Password"
                      value={values.password}
                      type={values.showpassword ? "text" : "password"}
                      onChange={handleChange("password")}
                      id="outlined-size-small"
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {values.showpassword && <img src={hii} alt="*" className="img" />}
                              {!values.showpassword && <img src={hello} alt="*" />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className={styles.confrim}>
                    <TextField
                      onChange={handleChange("confirmPassword")}
                      value={values.confirmPassword}
                      label="Confirm Password"
                      type="password"
                      id="outlined-size-small"
                      size="small"
                    />
                  </div>
                  <div className={styles.message}>
                    {values.confirmPassword.length > 0 && (
                      <span
                        className={`
                    ${
                      values.password === values.confirmPassword
                        ? styles.greencolor
                        : styles.redcolor
                    }
                  `}
                      >
                        {values.confirmPassword === values.password
                          ? "Password match"
                          : "Passwords do not match"}
                      </span>
                    )}
                  </div>
                  {error && <div className={styles.error}>*{error}</div>}
                  <div className={styles.button}>
                    <button
                      disabled={
                        values.confirmPassword.length > 0 &&
                        values.confirmPassword === values.password
                          ? false
                          : true
                      }
                      onClick={onSubmit}
                    >
                      Update
                    </button>
                  </div>
                </div>
              ) : (
                <div>{successComponent()}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const newCredentialsMobile = () => {
    return (
      <div>
        <div className="text">
          <div className={styles.mobilecontainer}>
            <div className={styles.bubblecontain}>
              <img src={bubbles2} alt="%" />
            </div>
            <div className={styles.name}>
              <div className={styles.uppername}>
                <span>EduUdr</span>
              </div>
              <div className={styles.lowername}>
                <span>upgrading the community</span>
              </div>
            </div>
            <div className={styles.in}>
              <div className={styles.head}>
                <span className={styles.newcredentials}>New Credentails</span>
              </div>
              {!success ? (
                <div>
                  <div className={styles.in1}>
                    <TextField
                      label="New Password"
                      value={values.password}
                      type={values.showpassword ? "text" : "password"}
                      onChange={handleChange("password")}
                      id="outlined-size-small"
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {values.showpassword && <img src={hii} alt="*" className="img" />}
                              {!values.showpassword && <img src={hello} alt="*" />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className={styles.confrim}>
                    <TextField
                      onChange={handleChange("confirmPassword")}
                      value={values.confirmPassword}
                      label="Confirm Password"
                      type="password"
                      id="outlined-size-small"
                      size="small"
                    />
                  </div>
                  <div className={styles.message}>
                    {values.confirmPassword.length > 0 && (
                      <span
                        className={`
                    ${
                      values.password === values.confirmPassword
                        ? styles.greencolor
                        : styles.redcolor
                    }
                  `}
                      >
                        {values.confirmPassword === values.password
                          ? "Password match"
                          : "Passwords do not match"}
                      </span>
                    )}
                  </div>
                  {error && <div className={styles.error}>*{error}</div>}
                  <div className={styles.button}>
                    <button
                      disabled={
                        values.confirmPassword.length > 0 &&
                        values.confirmPassword === values.password
                          ? false
                          : true
                      }
                      onClick={onSubmit}
                    >
                      Update
                    </button>
                  </div>
                </div>
              ) : (
                <div>{successComponent()}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {newCredentialsPage()}
      {newCredentialsMobile()}
    </>
  );
};

export default NewCredentials;
